export default __webpack_public_path__ + "static/media/bratislava.64aeb545.jpg";